import React, {useCallback, useState} from 'react';
import {useTranslation} from 'react-i18next';

import {ConfirmationModal} from '@pexip/components';
import {TestId} from '../../test/testIds';

export const useBreakoutCloseAllRoomsConfirmationModal = ({
    onCloseRooms,
}: {
    onCloseRooms: () => void;
}) => {
    const {t} = useTranslation();
    const [isCloseRoomsModalOpen, setIsCloseRoomsModalOpen] = useState(false);

    const openBreakoutCloseAllRoomsConfirmationModal = useCallback(
        () => setIsCloseRoomsModalOpen(true),
        [],
    );

    const breakoutCloseAllRoomsConfirmationModal = (
        <ConfirmationModal
            cancelButtonText={t('common.cancel', 'Cancel')}
            cancelButtonTestid={TestId.CloseBreakoutRoomsModalCancel}
            confirmButtonText={t('common.yes', 'Yes')}
            confirmButtonTestid={TestId.CloseBreakoutRoomsModalConfirm}
            title={t(
                'breakouts.close-all-rooms-modal.title',
                'Close all rooms?',
            )}
            uniqueTitle={t(
                'breakouts.close-all-rooms-modal.title',
                'Close all rooms?',
            )}
            description={t(
                'breakouts.close-all-rooms-modal.description',
                'All participants will be moved to the main room.',
            )}
            isOpen={isCloseRoomsModalOpen}
            onConfirm={() => {
                setIsCloseRoomsModalOpen(false);
                onCloseRooms();
            }}
            onCancel={() => setIsCloseRoomsModalOpen(false)}
        />
    );

    return {
        breakoutCloseAllRoomsConfirmationModal,
        openBreakoutCloseAllRoomsConfirmationModal,
    };
};
